import {
  closestCenter,
  DndContext,
  DragOverlay,
  KeyboardSensor,
  MouseSensor,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { useEffect, useState } from "react";

import {
  restrictToParentElement,
  restrictToVerticalAxis,
} from "@dnd-kit/modifiers";
import { useDebounce } from "react-use";
import { PeriodItem } from "./PeriodItem";

const PeriodsContainer = (props) => {
  const [items, setItems] = useState([]);
  const [activeId, setActiveId] = useState(null);

  const [debouncedItems, setDebouncedItems] = useState([]);

  const [, cancel] = useDebounce(
    () => {
      if (items.length > 0) {
        setDebouncedItems(items);
      }
    },
    1000,
    [items],
  );

  useEffect(() => {
    if (debouncedItems.length > 0) {
      props.handleUpdate(debouncedItems);
    }
  }, [debouncedItems]);

  function handleDragStart(event) {
    setActiveId(items.find((item) => item.id === event.active.id));
  }

  useEffect(() => {
    setItems(
      props.periods.map((item, index) => ({
        ...item,
        id: item.id,
        order: index,
      })),
    )
  }, [props.periods]);

  const sensors = useSensors(
    useSensor(MouseSensor),
    useSensor(PointerSensor),
    useSensor(TouchSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <DndContext
        sensors={sensors}
        modifiers={[restrictToVerticalAxis, restrictToParentElement]}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
        onDragStart={handleDragStart}
      >
        <SortableContext items={items} strategy={verticalListSortingStrategy}>
          {items.map((item) => (
            <PeriodItem
              openColumnMenu={props.openColumnMenu}
              classes={props.classes}
              key={item.id}
              id={item.id}
              item={item}
            />
          ))}
        </SortableContext>
        <DragOverlay>
          {activeId ? (
            <PeriodItem
              style={{ boxShadow: "0px 9px 27px -3px rgba(0,0,0,0.3)" }}
              classes={props.classes}
              key={activeId.id}
              id={activeId.id}
              item={activeId}
            />
          ) : null}
        </DragOverlay>
      </DndContext>
    </div>
  );

  function handleDragEnd({ active, over }) {
    setActiveId(null);

    if (active.id !== over.id) {
      setItems((items) => {
        const oldIndex = items.findIndex((item) => item.id === active.id);
        const newIndex = items.findIndex((item) => item.id === over.id);

        return arrayMove(items, oldIndex, newIndex).map((item, index) => ({
          ...item,
          order: index,
        }));
      });
    }
  }
};

export default PeriodsContainer;
